import { SET_ALL_FIRMS } from "./actionTypes";

export const setAllFirmsAction = (firms: any) => {
    return {
        type: SET_ALL_FIRMS,
        payload: firms
    };
};
